
import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

export default (props) => (<Dialog
  open={props.show}
  //onClose={props.handleClose}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogContent>
    <DialogContentText id="alert-dialog-description">
      Profile Password
        </DialogContentText>
    <TextField type="password" value={props.value}
      onChange={props.updateSecreKey}
      placeholder='Enter Password'
      error={props.SecretKeyError}
      helperText={props.SecretKeyErrorText}
    /><br /><br /><br />
    <span style={{ textDecoration: 'underline', marginTop: '20px', cursor: 'pointer' }}
      onClick={props.generateOtp}>Forget Password </span>
  </DialogContent>
  <DialogActions>
    <Button onClick={props.handlePaymentInitAuth} color="primary">
      Submit
            </Button>
    <Button onClick={props.handleCancelPaymentInitAuth} color="secondary" autoFocus>
      Cancel
            </Button>
  </DialogActions>
</Dialog>)


// WEBPACK FOOTER //
// ./src/components/PaymentInitAuth.js